package com.milta.core.localization.translations.nl

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Bestand importeren",
    analysingTitle = "Bestand wordt geanalyseerd…",
    analysingSubtitle = "We identificeren de kolommen en detecteren de leveringen in het bestand.",
    fileSentSuffix = "net verzonden",
    structuredFormatBannerTitle = "Indeling herkend.",
    structuredFormatBannerMessage = "De kolommen zijn automatisch toegewezen, geen correctie nodig.",
    columnsInterpretedBannerTitle = "Kolommen automatisch geïnterpreteerd.",
    columnsInterpretedBannerMessage = "Controleer de gemarkeerde leveringen voordat u ze toevoegt.",
    completePillLabel = "Alles is compleet",
    invalidFileTitle = "Bestand niet ondersteund.",
    invalidFileMessage = "Importeer een geldig Excel- (.xlsx) of CSV-bestand (.csv).",
    chooseAnotherFileButton = "Ander bestand kiezen",
    extractionFailedTitle = "Dit bestand kan niet worden gelezen.",
    extractionFailedMessage = "De tabel lijkt leeg of de structuur werd niet herkend — controleer de inhoud of voer de leveringen handmatig in.",
    retryWithNewFileButton = "Opnieuw proberen met een ander bestand",
    serviceUnavailableTitle = "Analysedienst tijdelijk niet beschikbaar.",
    serviceUnavailableMessage = "Probeer het straks opnieuw, of voltooi deze levering intussen handmatig.",
)
